<style lang="less">
.fps-wrap {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: visible;

  .fps-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
    max-width: 100%;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .fps-label {
    flex-shrink: 0;
    width: 72px;
    padding-top: 6px;
    font-size: 12px;
    line-height: 1.4;
    color: var(--subtext2);
  }

  .fps-trigger {
    flex: 1;
    min-width: 0;
    max-width: 100%;
    min-height: 32px;
    padding: 5px 8px;
    border: 1px solid var(--border);
    border-radius: 4px;
    cursor: pointer;
    background: #fff;
    font-size: 12px;
    line-height: 1.5;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;

    &.disabled {
      cursor: not-allowed;
      color: #aaa;
      background: #f7f7f7;
    }

    &.placeholder {
      color: #aaa;
    }
  }

  .fps-trigger-text {
    display: block;
    width: 100%;
    max-width: 100%;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .fps-clear {
    flex-shrink: 0;
    margin-top: 6px;
    color: #aaa;
    cursor: pointer;
    padding: 4px;

    &:hover {
      color: var(--error);
    }
  }

  .fps-flags {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;
    padding-top: 6px;
  }

  .fps-flag-item {
    font-size: 12px;
    color: var(--text2, #333);
    white-space: nowrap;
  }
}

.fps-modal-history {
  padding: 8px 8px 0;
  border-bottom: 1px solid var(--border);
  background: #fff;
}

.fps-modal-history-title {
  font-size: 12px;
  color: var(--subtext2);
  margin-bottom: 6px;
}

.fps-modal-history-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-bottom: 8px;
}

.fps-modal-history-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 4px 8px;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
  background: #fff;
  transition: border-color 0.15s, color 0.15s;

  &:hover {
    border-color: var(--primary);
    color: var(--primary);
  }
}

.fps-history-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fps-history-count {
  flex-shrink: 0;
  min-width: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #f0f2f5;
  color: var(--subtext2);
  font-size: 11px;
  text-align: center;
}

.fps-modal-search {
  padding: 8px;
  border-bottom: 1px solid var(--border);
  background: #fff;
}

.fps-modal-tree {
  height: 420px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px;

  ::v-deep .l-node {
    align-items: flex-start;
    overflow: hidden;
  }

  ::v-deep .l-node-inner {
    align-items: flex-start;
    min-width: 0;
    box-sizing: border-box;
  }

  ::v-deep .l-node-text {
    flex: 1;
    min-width: 0;
    white-space: normal;
    word-break: break-word;
    line-height: 1.5;
  }

  ::v-deep .l-node-selected {
    .l-node-inner {
      background: var(--primary) !important;
      color: #fff !important;
    }

    .fps-node-form,
    .fps-node-muted,
    .fps-tree-node-title {
      color: #fff !important;
    }
  }
}

.fps-tree-node {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 6px;
  max-width: 100%;
  line-height: 1.5;
  word-break: break-word;
  white-space: normal;
}

.fps-tree-node-title {
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
}

.fps-modal-footer {
  padding: 8px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.fps-node-form {
  color: var(--primary);
}

.fps-node-muted {
  flex-shrink: 0;
  color: var(--subtext2);
  font-size: 12px;
  white-space: nowrap;
}
</style>

<template>
  <div class="fps-wrap">
    <div v-if="showFormSelect && !fixedFormId" class="fps-row">
      <span class="fps-label">目标表单</span>
      <div
        class="fps-trigger"
        :class="{ placeholder: !formLabel, disabled: !editable }"
        @click="openFormModal"
      >
        <span class="fps-trigger-text">{{ formLabel || '请选择表单' }}</span>
      </div>
      <Icon
        v-if="editable && localValue.presetForm_fID"
        type="md-close-circle"
        class="fps-clear"
        @click.stop="clearForm"
      />
    </div>

    <div v-if="effectiveFormId" class="fps-row">
      <span class="fps-label">表单位置</span>
      <div
        class="fps-trigger"
        :class="{ placeholder: !positionLabel, disabled: !editable }"
        @click="openStructureModal"
      >
        <span class="fps-trigger-text">{{ positionLabel || '请选择栏目或字段' }}</span>
      </div>
      <Icon
        v-if="editable && (localValue.targetContent || localValue.targetItem)"
        type="md-close-circle"
        class="fps-clear"
        @click.stop="clearPosition"
      />
    </div>

    <div v-if="showFlags && effectiveFormId" class="fps-row">
      <span class="fps-label">附加数据</span>
      <div class="fps-flags">
        <Checkbox
          v-for="flag in flagOptions"
          :key="flag.key"
          class="fps-flag-item"
          :value="!!localValue[flag.key]"
          :disabled="!editable"
          @on-change="toggleFlag(flag.key, $event)"
        >
          {{ flag.label }}
        </Checkbox>
      </div>
    </div>

    <Modal v-model="formModal" title="选择表单" :width="720" footer-hide @on-visible-change="onFormModalVisible">
      <div v-if="formHistory.length" class="fps-modal-history">
        <div class="fps-modal-history-title">常用表单</div>
        <div class="fps-modal-history-list">
          <div
            v-for="item in formHistory"
            :key="item.id"
            class="fps-modal-history-item"
            @click="selectHistoryForm(item)"
          >
            <span class="fps-history-name">{{ item.name || item.id }}</span>
            <span class="fps-history-count">{{ item.count || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="fps-modal-search">
        <Input v-model="formSearch" search clearable placeholder="输入名称或编号搜索" />
      </div>
      <Spin v-if="formTreeLoading" fix />
      <div v-if="formModal" class="fps-modal-tree">
        <BaseTree
          ref="formTree"
          manu
          subname="children"
          :data="filteredFormTree"
          :nodeRenderer="renderFormTreeNode"
          @event="handleFormTreeEvent"
        />
      </div>
      <div class="fps-modal-footer">
        <Button size="small" @click="formModal = false">取消</Button>
      </div>
    </Modal>

    <Modal v-model="structureModal" title="选择表单位置" :width="640" footer-hide @on-visible-change="onStructureModalVisible">
      <Spin v-if="structureLoading" fix />
      <div v-if="structureModal" class="fps-modal-tree">
        <BaseTree
          ref="structureTree"
          manu
          subname="items"
          :data="structureNodes"
          :nodeRenderer="renderStructureNode"
          @event="handleStructureTreeEvent"
        />
        <BaseEmpty v-if="!structureLoading && structureNodes.length === 0" msg="该表单暂无结构数据" />
      </div>
      <div class="fps-modal-footer">
        <Button size="small" @click="structureModal = false">取消</Button>
        <Button type="primary" size="small" :disabled="!draftStructure" @click="confirmStructure">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters } from 'vuex';

const FORM_HISTORY_MAX = 10;

const FLAG_KEYS = [
  { key: 'needItemTitle', label: '表单项标题' },
  { key: 'needCategory', label: '栏目名称' },
  { key: 'needProjectName', label: '项目名称' },
  { key: 'needInputDate', label: '录入日期' },
  { key: 'needInputor', label: '录入人' },
];

const EMPTY_VALUE = () => ({
  presetForm_fID: '',
  targetContent: '',
  targetItem: '',
  needItemTitle: false,
  needCategory: false,
  needProjectName: false,
  needInputDate: false,
  needInputor: false,
});

function normalizeBool(v) {
  return v === true || v === 1 || v === '1' || v === 'true';
}

function normalizeValue(v) {
  const base = EMPTY_VALUE();
  if (!v || typeof v !== 'object') return base;
  return {
    presetForm_fID: v.presetForm_fID != null ? String(v.presetForm_fID) : '',
    targetContent: v.targetContent != null && v.targetContent !== '' ? Number(v.targetContent) : '',
    targetItem: v.targetItem != null && v.targetItem !== '' ? Number(v.targetItem) : '',
    needItemTitle: normalizeBool(v.needItemTitle),
    needCategory: normalizeBool(v.needCategory),
    needProjectName: normalizeBool(v.needProjectName),
    needInputDate: normalizeBool(v.needInputDate),
    needInputor: normalizeBool(v.needInputor),
  };
}

function filterTree(nodes, keyword, subKey = 'children') {
  if (!keyword) return nodes;
  const q = keyword.trim().toLowerCase();
  if (!q) return nodes;

  const walk = (list) => {
    const out = [];
    (list || []).forEach((node) => {
      const children = walk(node[subKey]);
      const name = String(node.name || '').toLowerCase();
      const code = String(node.code || '').toLowerCase();
      const selfMatch = name.includes(q) || code.includes(q);
      if (selfMatch || children.length) {
        const copy = { ...node };
        if (children.length) copy[subKey] = children;
        else delete copy[subKey];
        if (selfMatch || children.length) out.push(copy);
      }
    });
    return out;
  };

  return walk(nodes);
}

function flattenForms(nodes, subKey = 'children', acc = []) {
  (nodes || []).forEach((node) => {
    if (node.isForm) {
      acc.push(node);
    }
    if (node[subKey] && node[subKey].length) {
      flattenForms(node[subKey], subKey, acc);
    }
  });
  return acc;
}

export default {
  name: 'FormPositionSelect',
  props: {
    value: {
      type: Object,
      default: null,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    platform: {
      type: String,
      default: 'pmis',
    },
    option: {
      type: Object,
      default: () => ({}),
    },
    /** 固定表单 ID：隐藏表单选择，仅选位置 */
    fixedFormId: {
      type: String,
      default: '',
    },
    showFormSelect: {
      type: Boolean,
      default: true,
    },
    showFlags: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      flagOptions: FLAG_KEYS,
      localValue: EMPTY_VALUE(),
      formModal: false,
      structureModal: false,
      formSearch: '',
      formTree: [],
      formTreeLoading: false,
      formNameMap: {},
      formHistory: [],
      structureNodes: [],
      structureLoading: false,
      draftFormId: '',
      draftFormName: '',
      draftStructure: null,
      structureSelectedNode: null,
    };
  },
  computed: {
    ...mapGetters('session', ['session']),
    resolvedPlatform() {
      return this.option.platform || this.platform || 'pmis';
    },
    effectiveFormId() {
      return String(this.fixedFormId || this.localValue.presetForm_fID || '');
    },
    formHistoryStorageKey() {
      const sid = (this.session && this.session.id) || 'anon';
      return `zzl_fps_form_history_${sid}_${this.resolvedPlatform}`;
    },
    filteredFormTree() {
      return filterTree(this.formTree, this.formSearch, 'children');
    },
    formLabel() {
      const id = this.effectiveFormId;
      if (!id) return '';
      return this.formNameMap[id] || id;
    },
    positionLabel() {
      const { targetContent, targetItem } = this.localValue;
      if (!targetContent) return '';
      const contentNode = this.structureNodes.find((n) => n.contentIndex === targetContent);
      const contentName = contentNode
        ? (contentNode.category || contentNode.title || `栏目 ${targetContent}`)
        : `栏目 ${targetContent}`;
      if (!targetItem) return contentName;
      const item = (contentNode && contentNode.items)
        ? contentNode.items.find((it) => it.itemIndex === targetItem)
        : null;
      const itemName = item ? (item.title || `字段 ${targetItem}`) : `字段 ${targetItem}`;
      return `${contentName} / ${itemName}`;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(v) {
        this.localValue = normalizeValue(v);
        this.applyFixedFormId();
        if (this.effectiveFormId && !this.formNameMap[this.effectiveFormId]) {
          this.ensureFormName(this.effectiveFormId);
        }
        if (this.effectiveFormId) {
          this.loadStructureNodes(this.effectiveFormId, false);
        }
      },
    },
    fixedFormId: {
      immediate: true,
      handler() {
        this.applyFixedFormId();
        if (this.effectiveFormId) {
          this.loadStructureNodes(this.effectiveFormId, false);
        }
      },
    },
    resolvedPlatform() {
      this.formTree = [];
      this.formNameMap = {};
      this.loadFormHistoryFromStorage();
    },
    formHistoryStorageKey() {
      this.loadFormHistoryFromStorage();
    },
  },
  created() {
    this.loadFormHistoryFromStorage();
  },
  methods: {
    loadFormHistoryFromStorage() {
      try {
        const raw = localStorage.getItem(this.formHistoryStorageKey);
        const list = raw ? JSON.parse(raw) : [];
        this.formHistory = Array.isArray(list) ? list.slice(0, FORM_HISTORY_MAX) : [];
        this.formHistory.forEach((item) => {
          if (item && item.id && item.name) {
            this.$set(this.formNameMap, item.id, item.name);
          }
        });
      } catch (e) {
        this.formHistory = [];
      }
    },
    recordFormHistory(formId, formName) {
      if (!formId) return;
      const id = String(formId);
      const name = formName || this.formNameMap[id] || id;
      const list = [...this.formHistory];
      const idx = list.findIndex((item) => item.id === id);
      if (idx >= 0) {
        list[idx] = {
          ...list[idx],
          name,
          count: (list[idx].count || 0) + 1,
        };
      } else {
        list.push({ id, name, count: 1 });
      }
      list.sort((a, b) => (b.count || 0) - (a.count || 0));
      const next = list.slice(0, FORM_HISTORY_MAX);
      this.formHistory = next;
      try {
        localStorage.setItem(this.formHistoryStorageKey, JSON.stringify(next));
      } catch (e) {
        /* ignore quota errors */
      }
    },
    applyFixedFormId() {
      if (!this.fixedFormId) return;
      const id = String(this.fixedFormId);
      if (this.localValue.presetForm_fID !== id) {
        this.localValue = normalizeValue({
          ...this.localValue,
          presetForm_fID: id,
        });
      }
    },
    emitValue(patch = {}) {
      const merged = { ...this.localValue, ...patch };
      if (this.fixedFormId) {
        merged.presetForm_fID = String(this.fixedFormId);
      }
      const next = normalizeValue(merged);
      this.localValue = next;
      this.$emit('input', cloneDeep(next));
      this.$emit('change', cloneDeep(next));
    },
    toggleFlag(key, checked) {
      this.emitValue({ [key]: !!checked });
    },
    openFormModal() {
      if (!this.editable || this.fixedFormId) return;
      this.draftFormId = this.localValue.presetForm_fID || '';
      this.draftFormName = this.formNameMap[this.draftFormId] || '';
      this.formSearch = '';
      this.loadFormHistoryFromStorage();
      this.formModal = true;
      if (!this.formTree.length) this.loadFormTree();
    },
    selectHistoryForm(item) {
      if (!item || !item.id) return;
      this.selectFormAndProceed(item.id, item.name || this.formNameMap[item.id] || item.id);
    },
    selectFormAndProceed(formId, formName) {
      if (!formId) return;
      this.draftFormId = formId;
      this.draftFormName = formName || formId;
      this.$set(this.formNameMap, formId, this.draftFormName);
      const changed = formId !== this.localValue.presetForm_fID;
      this.emitValue({
        presetForm_fID: formId,
        ...(changed ? { targetContent: '', targetItem: '' } : {}),
      });
      this.formModal = false;
      this.draftStructure = changed
        ? { targetContent: '', targetItem: '' }
        : {
          targetContent: this.localValue.targetContent || '',
          targetItem: this.localValue.targetItem || '',
        };
      this.structureSelectedNode = null;
      this.structureModal = true;
      this.loadStructureNodes(formId, true);
    },
    openStructureModal() {
      if (!this.editable || !this.effectiveFormId) return;
      this.draftStructure = {
        targetContent: this.localValue.targetContent || '',
        targetItem: this.localValue.targetItem || '',
      };
      this.structureSelectedNode = null;
      this.structureModal = true;
      this.loadStructureNodes(this.effectiveFormId, true);
    },
    onFormModalVisible(open) {
      if (open && this.draftFormId && this.$refs.formTree) {
        this.$nextTick(() => {
          const node = { id: this.draftFormId };
          this.$refs.formTree.select(node);
        });
      }
    },
    onStructureModalVisible(open) {
      if (!open) return;
      this.$nextTick(() => {
        const { targetContent, targetItem } = this.localValue;
        if (!targetContent || !this.$refs.structureTree) return;
        let node = null;
        if (targetItem) {
          const content = this.structureNodes.find((c) => c.contentIndex === targetContent);
          node = content && content.items ? content.items.find((it) => it.itemIndex === targetItem) : null;
        } else {
          node = this.structureNodes.find((c) => c.contentIndex === targetContent);
        }
        if (node) this.$refs.structureTree.select(node);
      });
    },
    loadFormTree() {
      this.formTreeLoading = true;
      return this.$api
        .get(`logined_zzl/form_tree?platform=${this.resolvedPlatform}`)
        .then((res) => {
          const payload = res.data || {};
          const list = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : []);
          this.formTree = list;
          const forms = flattenForms(list, 'children');
          const map = {};
          forms.forEach((f) => {
            map[f.id] = f.name || f.code || f.id;
          });
          this.formNameMap = { ...this.formNameMap, ...map };
        })
        .catch((e) => {
          this.Error && this.Error('表单目录加载失败：' + (e.message || e));
        })
        .finally(() => {
          this.formTreeLoading = false;
        });
    },
    ensureFormName(id) {
      if (!id || this.formNameMap[id]) return;
      if (!this.formTree.length) {
        this.loadFormTree().then(() => {
          if (!this.formNameMap[id]) this.$set(this.formNameMap, id, id);
        });
        return;
      }
      this.$set(this.formNameMap, id, id);
    },
    loadStructureNodes(fID, showLoading = true) {
      if (!fID) {
        this.structureNodes = [];
        return Promise.resolve();
      }
      if (showLoading) this.structureLoading = true;
      return this.$api
        .get(`logined_zzl/form_def?fID=${encodeURIComponent(fID)}`)
        .then((res) => {
          const data = (res.data && res.data.data) || res.data || {};
          const content = Array.isArray(data.content) ? data.content : [];
          if (data.title && fID) {
            this.$set(this.formNameMap, fID, data.title);
          }
          this.structureNodes = content.map((c, i) => {
            const contentIndex = i + 1;
            const items = (c.items || []).map((item, j) => ({
              ...item,
              id: item.name || `item-${contentIndex}-${j + 1}`,
              nodeType: 'item',
              contentIndex,
              itemIndex: j + 1,
              name: item.title || `字段 ${j + 1}`,
            }));
            return {
              ...c,
              id: c.name || `content-${contentIndex}`,
              nodeType: 'content',
              contentIndex,
              name: c.category || c.title || `栏目 ${contentIndex}`,
              items,
            };
          });
        })
        .catch((e) => {
          this.structureNodes = [];
          this.Error && this.Error('表单结构加载失败：' + (e.message || e));
        })
        .finally(() => {
          if (showLoading) this.structureLoading = false;
        });
    },
    handleFormTreeEvent(evt) {
      if (!evt || evt.type !== 'select') return;
      const node = evt.data;
      if (!node || !node.isForm) return;
      this.selectFormAndProceed(node.id, node.name || node.code || node.id);
    },
    handleStructureTreeEvent(evt) {
      if (!evt || evt.type !== 'select') return;
      const node = evt.data;
      if (!node) return;
      this.structureSelectedNode = node;
      if (node.nodeType === 'item') {
        this.draftStructure = {
          targetContent: node.contentIndex,
          targetItem: node.itemIndex,
        };
      } else if (node.nodeType === 'content') {
        this.draftStructure = {
          targetContent: node.contentIndex,
          targetItem: '',
        };
      }
    },
    confirmStructure() {
      if (!this.draftStructure) return;
      this.emitValue({
        targetContent: this.draftStructure.targetContent,
        targetItem: this.draftStructure.targetItem,
      });
      if (!this.fixedFormId) {
        this.recordFormHistory(
          this.effectiveFormId,
          this.formNameMap[this.effectiveFormId],
        );
      }
      this.structureModal = false;
    },
    clearForm() {
      if (this.fixedFormId) {
        this.emitValue({ targetContent: '', targetItem: '' });
        return;
      }
      this.emitValue(EMPTY_VALUE());
      this.structureNodes = [];
    },
    clearPosition() {
      this.emitValue({ targetContent: '', targetItem: '' });
    },
    renderFormTreeNode(h, node) {
      const code = node.code
        ? h('span', { class: 'fps-node-muted' }, String(node.code))
        : null;
      const archived = node.isArchived
        ? h('span', { class: 'fps-node-muted' }, '[已归档]')
        : null;
      const titleCls = node.isForm ? 'fps-tree-node-title fps-node-form' : 'fps-tree-node-title';
      return h('div', { class: 'fps-tree-node' }, [
        h('span', { class: titleCls }, node.name || '(未命名)'),
        code,
        archived,
      ]);
    },
    renderStructureNode(h, node) {
      const typeLabel = node.formType
        ? h('span', { class: 'fps-node-muted' }, `[${node.formType}]`)
        : null;
      const idx = node.itemIndex != null
        ? h('span', { class: 'fps-node-muted' }, `#${node.itemIndex}`)
        : node.contentIndex != null
          ? h('span', { class: 'fps-node-muted' }, `#${node.contentIndex}`)
          : null;
      return h('div', { class: 'fps-tree-node' }, [
        h('span', { class: 'fps-tree-node-title' }, node.name || node.title || node.category),
        idx,
        typeLabel,
      ]);
    },
  },
};
</script>
